<h4 class="text-xl font-semibold mt-4 pl-3 pr-3">
  {{ '#WORK_NOTE.DIALOGS.SIGNATURE.TITLE' | translate }}
</h4>

<div class="signature-input pl-3 pr-3 pt-1 border-box" #input>
  <soft-signature-pad
    #signaturepad
    [options]="{
      minWidth: 2,
      canvasWidth: input.offsetWidth - 2,
      canvasHeight: input.offsetHeight
    }"
  ></soft-signature-pad>
</div>

<div class="flex flex-row flex-nowrap mt-3">
  <button class="soft-button secondary fill-force" (click)="close(null)">
    {{ '#WORK_NOTE.DIALOGS.SIGNATURE.CANCEL_BTN' | translate }}
  </button>
  <button
    class="soft-button primary fill-force"
    (click)="signaturepad.isEmpty() ? sign('') : sign(signaturepad.toDataUri())"
    [disabled]="isSaving"
    >
    <span>
      @if (isSaving) {
        <i class="fa-regular fa-spinner fa-spin"></i>
      }
      {{ '#WORK_NOTE.DIALOGS.SIGNATURE.SAVE_BTN' | translate }}
    </span>
  </button>
</div>
